<div [class.hidden]="!isLauncherVisible" class="zen-desk-widget" (click)="onClick()">
    <mat-icon [svgIcon]="isWindowOpen ? 'chevronDown' : 'questionMark'"></mat-icon>
</div>
